import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Zone } from "../../zones/_types/zone";

export class ContractZone extends Resource {
    public override type = 'contractZones';
    
    @prop()
    public contractId!: string;
   /* @prop()
    public name!: string; */     

    @prop()
    public zoneId!: string;
    @prop()
    public zone?: Zone;

}